export const cookieService = {
  get: (name) => {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts
        .pop()
        .split(';')
        .shift();
    }
    return null;
  },

  set: (
    name,
    value,
    expires,
    path,
    sameSite = 'Strict'
  ) => {
    let cookieValue = `${name}=${value}${path ? `;path=${path}` : ''};SameSite=${sameSite}`;
    // Set the top domain on the cookie if in prod or staging
    if (document.location.host.includes('switchcraft.co.uk')) {
      cookieValue += ';domain=.switchcraft.co.uk';
    }
    if (expires) cookieValue += `;expires='${expires.toUTCString()}';path=/`;
    document.cookie = cookieValue;
  }
};
